export default __webpack_public_path__ + "static/media/Top.4b382a3f.svg";